import React from "react";
import { useNavigate } from "react-router-dom";
import "./PlantationTwoDecor.scss";

const PlantationTwoDecor = () => {
  const navigate = useNavigate();

  const slides = [
    {id: 1,img: "/assets/decor/gateway-decor.png",title: "Gateway Glamour",desc: "Make a grand first impression with elegant entry designs!",},
    {id: 2,img: "/assets/decor/table-decor.png",title: "Happy Table Decor",desc: "Elevate every meal with exquisite table settings!",},
    {id: 3,img: "/assets/decor/decor.png",title: "Festive Joy Decor",desc: "Brighten your celebrations with vibrant cultural charm!",},
    {id: 4,img: "/assets/decor/dremy-wedding.png",title: "Dreamy Wedding Setup",desc: "Create a dreamy ambiance for your forever moment!",},
    {id: 5,img: "/assets/decor/birthday-decor.png",title: "Fun Birthday Vibes",desc: "Transform your special day with vibrant, personalized decor!",},
    // {id:6, img:  "https://cheetah.cherishx.com/uploads/1645594241_webp_original.webp",title:"Love Milestone Decor",desc:"Celebrate love with elegant and romantic setups!"},
    // {id:7, img:  "https://images.olx.com.pk/thumbnails/552473913-400x300.jpeg",title:"Fancy Luxe Decor",desc:"Luxury designs for stunning spaces!"}

  ];

  // Duplicate slides for infinite loop
  const infiniteSlides = [...slides, ...slides];

  const handleClick = () => {
    navigate("/products-two");
  };

  return (
    <div className="decor-wrapper">
   < h2 className="decor-heading">Exclusive Custom Decor</h2>
    <div className="decor-marquee">
      <div className="decor-track">
        {infiniteSlides.map((slide, index) => (
          <div key={index} className="decor-card" onClick={handleClick}>
            <img src={slide.img} alt={slide.title} />
            <div className="decor-content">
              <h3>{slide.title}</h3>
              <p>{slide.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default PlantationTwoDecor;